package com.tixforgigs.common.core.enums

import com.tixforgigs.tarami.GlobalMessage

enum class LoginMode(val index: Int, val title: String) {
  LOGIN(0, GlobalMessage.titleLogin()),
  SIGNUP(1, GlobalMessage.titleSignUp())
}
